module.exports = __webpack_public_path__ + "static/media/map.39df436c.png";